import LogoSmall from 'components/icons/LogoSmall';
import { useTranslation } from 'react-i18next';
import s from './styles';

function Footer({ width, paddingBottom }) {
  const { t } = useTranslation();
  return (
    <div
      style={{
        background: 'white',
      }}
    >
      <s.bar />
      <s.footerContainer width={width} paddingBottom={paddingBottom}>
        <s.container>
          <s.rightsReserved>
            {t('components.common.Footer.allRightsReserved',
              {
                year: new Date().getFullYear(),
                version: `V.${process.env.REACT_APP_BUILD_VERSION}.${process.env.REACT_APP_BUILD_ENV}`,
              }
            )}
          </s.rightsReserved>
          <s.containerlogo href="/">
            <LogoSmall />
          </s.containerlogo>
          <s.links
            style={{
              display: 'flex',
              gap: '20px',
            }}
          >
            <p> {t('components.common.Footer.termsAndConditions')}</p>
            <p> {t('components.common.Footer.support')}</p>
          </s.links>
        </s.container>
      </s.footerContainer>
    </div>
  );
}

export default Footer;
